
import React from 'react';

const Footer = () => {
  const footerStyle = {
    textAlign: 'center',
    background: 'transparent',
    backgroundColor: 'none',
    color:'white',
    fontSize: '12px',
    fontWeight: 'bold',
    marginTop: 'auto',
    padding: '10px 0',
  };

  return (
    <footer style={footerStyle}>
      <p>© 2025 Beas Jana 💌</p>
    </footer>
  );
};

export default Footer;

